<template>
    <div class="content">
        <div class="container">
            <div class="title">
                <h2>{{advantage.en}}</h2>
                <p>
                    —————— &nbsp;
                    <span>{{advantage.ch}}</span> &nbsp; ——————
                </p>
            </div>
            <div class="card">
                <ul>
                    <li v-for="(item,index) in advantage.card" :key="index" class="animate__animated" v-animate="item.animate">
                        <div class="icon">
                            <i class="iconfont" :class="item.icon"></i>
                        </div>
                        <div class="num">
                            {{item.num}}<span v-if="item.span">{{item.span}}</span>
                        </div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="advertising-position container">
        <div class="title">
            <p>{{advertisingPosition.ch}}</p>
            <p>{{advertisingPosition.en}}</p>
        </div>
        <div class="img" v-for="(item, index) in advertisingPosition.img" :key="index">
            <img :src="item.url" alt />
            <div class="extra">
                <p>{{item.extra.title}}</p>
                <p>{{item.extra.con}}</p>
            </div>
        </div>
    </div>
    <div class="our-serve">
        <div class="container">
            <div class="title">
                <p>{{ourServe.ch}}</p>
                <p>{{ourServe.en}}</p>
                <p></p>
            </div>
            <div class="card">
                <ul>
                    <li v-for="(item,index) in ourServe.card" :key="index">
                        <i class="iconfont" :class="item.icon"></i>
                        <div class="title">{{item.title}}</div>
                        <div class="explain">{{item.explain}}</div>
                        <div class="btn cursor" @click="jump">{{item.btn}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="advertising-people container">
        <div class="title">
            <p>{{advertisingPeople.ch}}</p>
            <p>{{advertisingPeople.en}}</p>
        </div>
        <div class="img" v-for="(item, index) in advertisingPeople.img" :key="index">
            <img :src="item.url" alt />
            <div class="extra">
                <p>{{item.extra.title}}</p>
                <p>{{item.extra.con}}</p>
            </div>
        </div>
    </div>
    <div class="case" id="case">
        <div class="container">
            <div class="title">
                <p>{{cases.ch}}</p>
                <p>{{cases.en}}</p>
                <p></p>
            </div>
            <div class="img-no-transform">
                <img :src="cases.img" alt />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HomeAdvantage',
  setup () {
    const jump = () => {
      document.querySelector('#footer').scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐。默认值
      })
    }
    // 优势
    const advantage = {
      en: 'ADVANTAGE',
      ch: 'Soul的优势',
      card: [
        { animate: 'animate__fadeInLeft animate__delay-1s', icon: 'icon-shijian', num: '68', span: 'min', explain: '日均用户在线时长' },
        { animate: 'animate__fadeInLeft', icon: 'icon-good', num: '72%', explain: 'Z世代用户占比' },
        { animate: 'animate__fadeInRight', icon: 'icon-yonghuguanli_huaban', num: '2亿', span: '+', explain: '注册用户数' },
        { animate: 'animate__fadeInRight animate__delay-1s', icon: 'icon-benkexueli', num: '79%', explain: '本科学历占比' }
      ]
    }
    // 广告位
    const advertisingPosition = {
      en: 'SOUL ADVERTISING PLACE',
      ch: 'Soul广告位介绍',
      img: [
        { url: require('../../../assets/images/25005305.png'), extra: { title: 'Soul开屏广告位', con: 'Soul开屏广告位目前只支持品牌广告投放，效果广告将在后期陆续开放' } },
        { url: require('../../../assets/images/25005386.png'), extra: { title: '信息流广告位', con: '信息流广告位包括“推荐”频道的信息流第五位帖子以及帖子详情页广告位' } }
      ]
    }
    // 我们的服务
    const ourServe = {
      en: 'SERVICE PHILOSOPHY',
      ch: '我们的服务',
      card: [
        { icon: 'icon-shandian', title: '快速响应', explain: '我们提供7x18小时的全天候响应速度随时随地为您服务', btn: '联系我们' },
        { icon: 'icon-dengpaobulb', title: '开户与运营', explain: '我们会为各位客户提供开户前的咨询、资质提交审核、投放策略计划的制定、投放素材设计与制作以及后续效果优化分析等服务', btn: '联系我们' },
        { icon: 'icon-fuwu', title: '大客户1V1服务', explain: '我们针对投放预算较大的客户安排单独的项目组进行1V1的服务，全时段的专门服务于大客户', btn: '联系我们' }
      ]
    }
    // 人群特点
    const advertisingPeople = {
      en: 'POPULATION CHARACTERISTICS',
      ch: 'Soul的人群特点',
      img: [
        { url: require('../../../assets/images/25005615.png'), extra: { title: 'Soul的用户性别、年龄、地域、学历等属性', con: '年轻优质群体赋能品牌年轻化升级' } },
        { url: require('../../../assets/images/25005616.png'), extra: { title: 'Soul平台用户的行为属性', con: '多元化的生活内容分享，结识志同道合的朋友' } }
      ]
    }
    // 案例
    const cases = {
      en: 'ADVERTISING CASES',
      ch: 'Soul广告客户案例',
      img: require('../../../assets/images/25005879.png')
    }

    return { jump, advantage, advertisingPosition, ourServe, advertisingPeople, cases }
  }
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 505px;
  width: 100%;
  background: url(~@/assets/images/2000000668.png) repeat 50%;
  background-attachment: scroll;
  background-size: auto;
  position: relative;
  transition: all, 0.3s;
  .container {
    padding: 56px;
    .title {
      text-align: center;
      h2 {
        font-size: 30px;
        margin-bottom: 10px;
      }
      p {
        color: #5d5d5d;
        font-size: 16px;
        span {
          color: #fff;
        }
      }
    }
  }
  .card {
    padding-top: 30px;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #5d5d5d;
      border-radius: 50%;
      width: 100px;
      height: 100px;
      .iconfont {
        font-size: 50px;
      }
    }
    ul {
      display: flex;
      justify-content: space-between;
      li {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 220px;
        height: 278px;
        .num {
          font-size: 50px;
          font-weight: 800;
          margin: 6px;
          > span {
            font-size: 30px;
          }
        }
      }
    }
  }
}
.advertising-position,
.advertising-people,
.our-serve,
.case {
  padding: 40px 24px;
  .title {
    font-size: 30px;
    color: #000;
    p {
      text-align: center;
      &:nth-child(2) {
        margin-top: 1px;
        font-size: 12px;
        color: #222;
      }
    }
  }
  .img {
    position: relative;
    margin-top: 24px;
    border: 1px solid #76c7c0;
    overflow: hidden;
    &:hover img {
      transform: scale(1.2);
      transition: all 0.5s;
    }
    .extra {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      left: 0;
      bottom: 0;
      opacity: 0;
      transform: translate3d(0, 100%, 0);
      transition: all 0.5s;
      p {
        text-align: center;
        color: #f4f406;
        font-size: 20px;
        &:last-child {
          margin-top: 10px;
          color: #fff;
        }
      }
    }
    &:hover {
      .extra {
        opacity: 1;
        transform: none;
      }
    }
  }
}
.advertising-people {
  .img {
    border: none;
  }
}
.our-serve {
  height: 686px;
  background: url(~@/assets/images/-47766.png) no-repeat 50%;
  .title {
    p {
      &:last-child {
        width: 50px;
        height: 4px;
        background-color: #cccccc;
        border-radius: 2px;
        margin: 10px auto 20px;
      }
    }
  }
  .card {
    ul {
      display: flex;
      height: 490px;
      color: #fff;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        padding: 60px 24px;
        &:nth-child(1) {
          background-color: #9fc4f2;
        }
        &:nth-child(2) {
          background-color: #80b2ee;
        }
        &:nth-child(3) {
          background-color: #609ee9;
        }
        .iconfont {
          font-size: 60px;
          color: #fff;
        }
        .title {
          color: #fff;
        }
        .explain {
          flex: 1;
          margin: 40px auto;
          text-align: center;
          line-height: 2;
        }
        .btn {
          padding: 12px 40px;
          border: 1px solid #fff;
          border-radius: 40px;
          &:hover {
            background-color: #fff;
            color: #609ee9;
          }
        }
      }
    }
  }
}
.case {
  background: url(~@/assets/images/2100000078.png) repeat 50%;
  .img-no-transform {
    margin-top: 24px;
    text-align: center;
  }
}
</style>
